export default "__VITE_ASSET__By8MtNjH__"